import React, { useState } from "react";
import Navbar from '../../components/Navbar';
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const ProfessionalDetails =  () => {
  const ID = Cookies.get("log_id");
  const [job,setJob] = useState("");
  const [company,setCompany] = useState("");
  const [from,setFrom] = useState("");
  const [to,setTo] = useState("");
  const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
      const navigate = useNavigate();
  function UnemployedRegistration3(e) {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append('id',ID);
    formdata.append('job',job);
    formdata.append('company',company);
    formdata.append('from',from);
    formdata.append('to',to);
    axios.put(`${url.path}/unemployed_regist3/`,formdata)
    .then((res) =>{
      if (res.data.status){
        Toast.fire({
          icon:'success',
          title:'Registration Success Wait for Approval...'
        })
        navigate("/login");
      }
    })
    .catch((err) => {
      Toast.fire({
        icon:'error',
        title:`${err}`
      })
    });
  }

  return (
    <>
    <Navbar />
    <div className="education-form">
      
      <form  className="education-form-container" onSubmit={UnemployedRegistration3}>
        <h2>Add Experiance</h2>
        <label>
        Job Position
          <input type="text" name="course" placeholder="Enter job name" value={job} onChange={(e) =>setJob(e.target.value)} />
        </label>
        <label>
          Organization Name
          <input type="text" name="institution" placeholder="Enter Organization name" value={company} onChange={(e) =>setCompany(e.target.value)} />
        </label>
        <div className="date-inputs">
          <label>
            From
            <input type="date" name="from" required value={from} onChange={(e) =>setFrom(e.target.value)} />
          </label>
          <label>
            To
            <input type="date" name="to" required value={to} onChange={(e) =>setTo(e.target.value)} />
          </label>
        </div>
        
        <br />
       
        <button type="submit" className="continue2-btn" >
          Register
        </button>
      </form>
    </div>
    </>
  );
};

export default ProfessionalDetails;
